module.exports = __webpack_public_path__ + "img/CTWP__Sword_02.15177305.png";